import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface ForbiddenAccessProps {
  message?: string;
  showBackButton?: boolean;
}

export const ForbiddenAccess = ({
  message = "You don't have permission to access this resource.",
  showBackButton = true,
}: ForbiddenAccessProps) => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="400px"
      textAlign="center"
      gap={3}
    >
      <Typography
        variant="h1"
        color="error"
        sx={{ fontSize: "72px", fontWeight: "bold" }}
      >
        403
      </Typography>
      <Typography variant="h5" color="textSecondary">
        Access Forbidden
      </Typography>
      <Typography variant="body1" color="textSecondary" maxWidth="400px">
        {message}
      </Typography>
      {showBackButton && (
        <Button variant="contained" onClick={() => navigate(-1)} sx={{ mt: 2 }}>
          Go Back
        </Button>
      )}
    </Box>
  );
};

export default ForbiddenAccess;
